import type { FrontendWidget } from '../types';
import {
  DEFAULT_DIVIDER_COLOR,
  DEFAULT_DIVIDER_SPACING,
  HorizontalDividerComponent,
} from './HorizontalDividerComponent';
import type {
  HorizontalDividerConfig,
  HorizontalDividerResolved,
} from './types';

export const horizontalDividerWidget: FrontendWidget<
  HorizontalDividerConfig,
  HorizontalDividerResolved
> = {
  componentType: 'widgets.horizontal-divider',
  displayName: 'Horizontal Divider',
  defaultValues: {
    color: DEFAULT_DIVIDER_COLOR,
    spacing: DEFAULT_DIVIDER_SPACING,
  },
  ComponentA: HorizontalDividerComponent,
  resolveSync: (config) => ({
    // Both mirror the Strapi defaults, for entries written before the fields
    // existed and for a row whose enum was edited out from under us.
    color: config.color ?? DEFAULT_DIVIDER_COLOR,
    spacing: config.spacing ?? DEFAULT_DIVIDER_SPACING,
  }),
};
